/**
 * 2015-04-14 - Jean-François Sanfaçon <jfsanfacon@imarcom.net>
 */
;(function($, undefined) {
	$.openModal.locale = {
		close_label: 'Fermer',
		error_title: 'Erreur',
		error_happend: 'Une erreur s\'est produite.',
		error_unknow_happend: 'Une erreur inconnue s\'est produite.',
		error_try_again_later: 'Veuillez réessayer plus tard.'
	};
}(jQuery));
